import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { DataBerkas } from "@/types";
import { Ban, CheckCircle2, Clock, Eye, Users } from "lucide-react";

const ValidationDashboard = ({ data = [] }: { data: any[] }) => {
  // 1. Logika Pengolahan Data Berdasarkan Surat Keterangan Tidak Buta Warna
  const stats = data.reduce(
    (acc, curr) => {
      // Cari berkas spesifik sesuai ketentuan
      const berkasButawarna = curr?.data_berkas?.find(
        (item: DataBerkas) =>
          item.sys_berkas?.jenis_berkas?.slug_jenis_berkas ===
          "Surat_Keterangan_Tidak_Buta_Warna",
      );

      const isValid = berkasButawarna?.is_valid;

      // Handling logic status
      if (isValid === null || isValid === undefined) {
        acc.menunggu++;
      } else if (isValid) {
        acc.valid++;
      } else {
        acc.tidakValid++;
      }
      return acc;
    },
    { valid: 0, menunggu: 0, tidakValid: 0 },
  );

  const total = data.length;
  const processed = stats.valid + stats.tidakValid;
  const progressPercentage =
    total > 0 ? Math.round((processed / total) * 100) : 0;

  const chartItems = [
    {
      label: "Valid",
      value: stats.valid,
      color: "bg-emerald-500",
      icon: <CheckCircle2 className="w-5 h-5" />,
    },
    {
      label: "Tidak Valid",
      value: stats.tidakValid,
      color: "bg-destructive", // Merah
      icon: <Ban className="w-5 h-5" />,
    },
    {
      label: "Menunggu Validasi",
      value: stats.menunggu,
      color: "bg-amber-500", // Kuning/Oranye
      icon: <Clock className="w-5 h-5" />,
    },
  ];

  return (
    <div className="space-y-6 mb-8 transition-all duration-300">
      {/* --- MAIN HEADER STATS --- */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary/10 text-primary rounded-xl">
            <Eye className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-2xl font-bold tracking-tight">
              Progress Verifikasi Buta Warna
            </h2>
            <p className="text-muted-foreground text-sm">
              Status validasi dokumen Surat Keterangan Tidak Buta Warna
              pendaftar.
            </p>
          </div>
        </div>
        <div className="flex items-baseline gap-2 bg-primary/5 px-4 py-2 rounded-2xl border border-primary/10">
          <span className="text-4xl font-black text-primary tracking-tighter">
            {progressPercentage}%
          </span>
          <span className="text-sm font-medium text-primary/70 uppercase tracking-wider">
            Selesai
          </span>
        </div>
      </div>

      {/* --- PROGRESS BAR MINIMALIS --- */}
      <div className="space-y-2">
        <Progress
          value={progressPercentage}
          className="h-2 bg-slate-100 dark:bg-slate-800"
        />
        <div className="flex justify-between text-[11px] font-bold uppercase tracking-widest text-muted-foreground/70">
          <span>Mulai 0%</span>
          <span>
            {processed} Terverifikasi dari {total} Dokumen
          </span>
          <span>Target 100%</span>
        </div>
      </div>

      {/* --- GRID STATS CARDS --- */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Total Data */}
        <Card className="p-4 bg-slate-50/50 dark:bg-slate-900/50 border-slate-200 dark:border-slate-800 shadow-none">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-blue-500/10 text-blue-600 rounded-lg">
              <Users className="w-5 h-5" />
            </div>
            <div className="space-y-0.5">
              <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
                Total Peserta
              </p>
              <h3 className="text-xl font-bold leading-none">{total}</h3>
            </div>
          </div>
        </Card>

        {/* Dynamic Cards (Valid, Tidak Valid, Menunggu) */}
        {chartItems.map((item, idx) => (
          <Card
            key={idx}
            className="p-4 bg-background dark:bg-card border-slate-200 dark:border-slate-800 shadow-sm hover:border-primary/20 transition-colors"
          >
            <div className="flex items-center gap-3">
              <div
                className={`p-2 ${item.color.replace("bg-", "bg-").replace("500", "500/10")} ${item.color.replace("bg-", "text-")} rounded-lg`}
              >
                {item.icon}
              </div>
              <div className="space-y-0.5">
                <p className="text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
                  {item.label}
                </p>
                <h3 className="text-xl font-bold leading-none">{item.value}</h3>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* --- MINI STACKED DISTRIBUTION BAR --- */}
      {/* <div className="pt-2">
        <div className="flex h-1.5 w-full rounded-full overflow-hidden bg-slate-100 dark:bg-slate-800">
          {chartItems.map((item, idx) => (
            <div
              key={idx}
              style={{
                width: `${total > 0 ? (item.value / total) * 100 : 0}%`,
              }}
              className={`${item.color} opacity-90 transition-all duration-700`}
            />
          ))}
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-2 mt-3">
          {chartItems.map((item, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <div className={`w-1.5 h-1.5 rounded-full ${item.color}`} />
              <span className="text-xs font-medium text-muted-foreground/80">
                {item.label}:{" "}
                <span className="text-foreground font-bold">{item.value}</span>
              </span>
            </div>
          ))}
        </div>
      </div> */}
    </div>
  );
};

export default ValidationDashboard;
